import { render, staticRenderFns } from "./TransferTargetInfoView.vue?vue&type=template&id=553f42da&scoped=true&"
import script from "./TransferTargetInfoView.vue?vue&type=script&lang=js&"
export * from "./TransferTargetInfoView.vue?vue&type=script&lang=js&"
import style0 from "./TransferTargetInfoView.vue?vue&type=style&index=0&id=553f42da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553f42da",
  null
  
)

export default component.exports